"use client";
import React from "react";
import AlgoliaSearch from "@/components/algolia-search";
import { IoClose } from "react-icons/io5";
import Container from "@/components/Container";
import useSearchStore from "@/stores/search-store";

const SearchOverlayBlock = ({ close }) => {
  const hideSearch = useSearchStore((state) => state.hideSearch);
  const searchModalVisible = useSearchStore(
    (state) => state.searchModalVisible,
  );

  if (!searchModalVisible) return null;

  return (
    <div
      className={
        "bg-[rgba(0,0,0,0.85)] max-h-screen min-h-screen w-full fixed z-100 top-0 left-0 overflow-auto"
      }
    >
      <Container className={"text-right pt-2 xl:pt-10"}>
        <button
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            hideSearch();
          }}
          className={"text-white"}
        >
          <IoClose size={32} />
        </button>
        <div className={"mt-3 lg:mt-8 text-left"}>
          <AlgoliaSearch callback={hideSearch} />
        </div>
      </Container>
    </div>
  );
};

export default SearchOverlayBlock;
